import api from '../api';

/*
 * DESATIVADO: Funcionalidade de importação de leads em jornadas
 * Esta função foi desativada e não é mais usada.
 * Deixando comentado para referência futura.
 */

/*
export const createBulkOpportunitiesForCampaign = async (campaignData) => {
    const {
        enterpriseId,
        journeyId,
        contactFilter,
        selectedSegments,
        selectedEnterprises,
        filterValue,
        opportunityName,
        selectedColumn,
        selectedTags,
        selectedCustomFields,
        onError
    } = campaignData;

    console.log("[CreateBulk] Iniciando criação em massa de oportunidades (frontend)");

    try {
        // Passo 1: Buscar contatos com filtro
        console.log("[CreateBulk] Buscando contatos com filtro:", contactFilter, filterValue);
        
        let filterParams = {};
        
        if (contactFilter === 'telephone' && filterValue) {
            // Buscar DDD no formato internacional: +55DDD
            // Ex: filterValue="21" busca por "+5521"
            filterParams.telephone__startswith = `+55${filterValue}`;
        } else if (contactFilter === 'email' && filterValue) {
            filterParams.email__icontains = filterValue;
        } else if (contactFilter === 'contact_group' && selectedSegments?.length > 0) {
            filterParams.groups__in = selectedSegments;
        } else if (contactFilter === 'contact_enterprise' && selectedEnterprises?.length > 0) {
            filterParams.contact_enterprise_id__in = selectedEnterprises;
        }

        const contactsResponse = await api.get(`enterprises/${enterpriseId}/contacts/`, { params: filterParams });
        
        let contacts = [];
        if (Array.isArray(contactsResponse.data)) {
            contacts = contactsResponse.data;
        } else if (contactsResponse.data?.results) {
            contacts = contactsResponse.data.results;
        }

        console.log("[CreateBulk] Contatos encontrados:", contacts.length);

        if (!contacts || contacts.length === 0) {
            console.log("[CreateBulk] Nenhum contato encontrado");
            return { createdCount: 0, failedCount: 0 };
        }

        // Passo 2: Criar oportunidade para cada contato
        let createdCount = 0;
        let failedCount = 0;

        for (const contact of contacts) {
            try {
                const oppPayload = {
                    column: selectedColumn,
                    title: opportunityName,
                    contact: contact.id,
                    status: 'ACTIVE'
                };

                if (selectedTags?.length > 0) {
                    oppPayload.tags = selectedTags;
                }

                const oppResponse = await api.post(
                    `enterprises/${enterpriseId}/journeys/${journeyId}/opportunities/`,
                    oppPayload
                );

                if (oppResponse.status === 201) {
                    createdCount++;
                    console.log("[CreateBulk] Oportunidade criada para contato:", contact.id);
                } else {
                    failedCount++;
                }
            } catch (error) {
                failedCount++;
                console.error("[CreateBulk] Erro ao criar oportunidade para contato", contact.id, error);
            }
        }

        console.log("[CreateBulk] Resultado: criadas=" + createdCount + " falhadas=" + failedCount);
        return { createdCount, failedCount };

    } catch (error) {
        console.error("[CreateBulk] Erro geral:", error);
        if (onError) onError(error.message || 'Erro ao criar oportunidades');
        return { createdCount: 0, failedCount: 0 };
    }
};
*/


